import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {Client, ClientService} from '@app/admin/client.service';
import {UserPickerComponent} from '@app/user-picker/user-picker/user-picker.component';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'frog-transfer-dialog',
    templateUrl: './transfer-dialog.component.html',
    styleUrls: ['./transfer-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        ReactiveFormsModule,
        UserPickerComponent,
        MatFormField,
        MatInput,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        AsyncPipe,
    ],
})
export class TransferDialogComponent implements OnInit {
    public client$: Observable<Client>;
    public form: FormGroup;

    private workspaceName: string;

    constructor(
        private clientService: ClientService,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<TransferDialogComponent>,
    ) {
        this.form = this.formBuilder.group({
            confirm: ['', [Validators.required, this.nameMatchValidator()]],
            user: null,
        });
    }

    ngOnInit(): void {
        this.client$ = this.clientService.client.pipe(
            tap((client) => (this.workspaceName = client.config.data.name)),
        );
    }

    confirm() {
        const user = this.form.value.user;
        this.dialogRef.close(user);
    }

    nameMatchValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value === this.workspaceName
                ? null
                : { nameMatch: { value: control.value } };
        };
    }
}
